import { render, staticRenderFns } from "./Visuals.vue?vue&type=template&id=70a6a85e&scoped=true&"
import script from "./Visuals.js?vue&type=script&lang=js&"
export * from "./Visuals.js?vue&type=script&lang=js&"
import style0 from "./Visuals.scss?vue&type=style&index=0&id=70a6a85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a6a85e",
  null
  
)

export default component.exports